var FlagCondition;
(function (FlagCondition) {
    FlagCondition[FlagCondition["NZ"] = 0] = "NZ";
    FlagCondition[FlagCondition["Z"] = 1] = "Z";
    FlagCondition[FlagCondition["NC"] = 2] = "NC";
    FlagCondition[FlagCondition["C"] = 3] = "C";
})(FlagCondition || (FlagCondition = {}));
// ****************
// * Call nn
// ****************
export function createCallAndReturnOperations() {
    const { registers, memory } = this;
    const cpu = this;
    this.addOperation({
        get instruction() {
            const toAddress = memory.readWord(registers.programCounter.value);
            return `CALL 0x${toAddress.toString(16)}`;
        },
        byteDefinition: 0b11_001_101,
        byteLength: 3,
        cycleTime: 24,
        execute() {
            const callToAddress = memory.readWord(registers.programCounter.value);
            registers.programCounter.value += 2;
            const returnToAddress = registers.programCounter.value;
            cpu.pushToStack(returnToAddress);
            registers.programCounter.value = callToAddress;
        }
    });
    // ****************
    // * Call cc, nn
    // ****************
    function getCallConditionByteDefinition(flagCondition) {
        return (0b11 << 6) + (flagCondition << 3) + 0b100;
    }
    this.addOperation({
        get instruction() {
            const toAddress = memory.readWord(registers.programCounter.value);
            return `CALL NZ, 0x${toAddress.toString(16)}`;
        },
        byteDefinition: getCallConditionByteDefinition(FlagCondition.NZ),
        byteLength: 3,
        get cycleTime() {
            return !registers.F.isResultZero ? 24 : 12;
        },
        execute() {
            if (!registers.F.isResultZero) {
                const toAddress = memory.readWord(registers.programCounter.value);
                registers.programCounter.value += 2;
                const returnToAddress = registers.programCounter.value;
                cpu.pushToStack(returnToAddress);
                registers.programCounter.value = toAddress;
            }
            else {
                registers.programCounter.value += 2; // Skip to next operation after the word value following this one
            }
        }
    });
    this.addOperation({
        get instruction() {
            const toAddress = memory.readWord(registers.programCounter.value);
            return `CALL Z, 0x${toAddress.toString(16)}`;
        },
        byteDefinition: getCallConditionByteDefinition(FlagCondition.Z),
        byteLength: 12,
        get cycleTime() {
            return registers.F.isResultZero ? 6 : 3;
        },
        execute() {
            if (registers.F.isResultZero) {
                const toAddress = memory.readWord(registers.programCounter.value);
                registers.programCounter.value += 2;
                const returnToAddress = registers.programCounter.value;
                cpu.pushToStack(returnToAddress);
                registers.programCounter.value = toAddress;
            }
            else {
                registers.programCounter.value += 2; // Skip to next operation after the word value following this one
            }
        }
    });
    this.addOperation({
        get instruction() {
            const toAddress = memory.readWord(registers.programCounter.value);
            return `CALL NC, 0x${toAddress.toString(16)}`;
        },
        byteDefinition: getCallConditionByteDefinition(FlagCondition.NC),
        byteLength: 3,
        get cycleTime() {
            return !registers.F.isCarry ? 24 : 12;
        },
        execute() {
            if (!registers.F.isCarry) {
                const toAddress = memory.readWord(registers.programCounter.value);
                registers.programCounter.value += 2;
                const returnToAddress = registers.programCounter.value;
                cpu.pushToStack(returnToAddress);
                registers.programCounter.value = toAddress;
            }
            else {
                registers.programCounter.value += 2;
            }
        }
    });
    this.addOperation({
        get instruction() {
            const toAddress = memory.readWord(registers.programCounter.value);
            return `CALL C, 0x${toAddress.toString(16)}`;
        },
        byteDefinition: getCallConditionByteDefinition(FlagCondition.C),
        byteLength: 3,
        get cycleTime() {
            return registers.F.isCarry ? 24 : 12;
        },
        execute() {
            if (registers.F.isCarry) {
                const toAddress = memory.readWord(registers.programCounter.value);
                registers.programCounter.value += 2;
                const returnToAddress = registers.programCounter.value;
                cpu.pushToStack(returnToAddress);
                registers.programCounter.value = toAddress;
            }
            else {
                registers.programCounter.value += 2;
            }
        }
    });
    // ****************
    // * Return
    // ****************
    this.addOperation({
        instruction: 'RET',
        byteDefinition: 0b11_001_001,
        byteLength: 1,
        cycleTime: 16,
        execute() {
            registers.programCounter.value = cpu.popFromStack();
        }
    });
    this.addOperation({
        instruction: 'RETI',
        byteDefinition: 0b11_011_001,
        byteLength: 1,
        cycleTime: 16,
        execute() {
            registers.programCounter.value = cpu.popFromStack();
            cpu.isInterruptMasterEnable = true;
        }
    });
    // ****************
    // * Return cc
    // ****************
    function getRetConditionByteDefinition(flagCondition) {
        return (0b11 << 6) + (flagCondition << 3);
    }
    this.addOperation({
        instruction: 'RET NZ',
        byteDefinition: getRetConditionByteDefinition(FlagCondition.NZ),
        byteLength: 1,
        get cycleTime() {
            return !registers.F.isResultZero ? 20 : 8;
        },
        execute() {
            if (!registers.F.isResultZero) {
                registers.programCounter.value = cpu.popFromStack();
            }
        }
    });
    this.addOperation({
        instruction: 'RET Z',
        byteDefinition: getRetConditionByteDefinition(FlagCondition.Z),
        byteLength: 1,
        get cycleTime() {
            return registers.F.isResultZero ? 20 : 8;
        },
        execute() {
            if (registers.F.isResultZero) {
                registers.programCounter.value = cpu.popFromStack();
            }
        }
    });
    this.addOperation({
        instruction: 'RET NC',
        byteDefinition: getRetConditionByteDefinition(FlagCondition.NC),
        byteLength: 1,
        get cycleTime() {
            return !registers.F.isCarry ? 20 : 8;
        },
        execute() {
            if (!registers.F.isCarry) {
                registers.programCounter.value = cpu.popFromStack();
            }
        }
    });
    this.addOperation({
        instruction: 'RET C',
        byteDefinition: getRetConditionByteDefinition(FlagCondition.C),
        byteLength: 1,
        get cycleTime() {
            return registers.F.isCarry ? 20 : 8;
        },
        execute() {
            if (registers.F.isCarry) {
                registers.programCounter.value = cpu.popFromStack();
            }
        }
    });
    // ****************
    // * Restart t
    // ****************
    function getRstConditionByteDefinition(operand) {
        return (0b11 << 6) + (operand << 3) + 0b111;
    }
    const operandToAddress = [
        0x0000,
        0x0008,
        0x0010,
        0x0018,
        0x0020,
        0x0028,
        0x0030,
        0x0038,
    ];
    for (let operand = 0; operand < 8; operand++) {
        this.addOperation({
            byteDefinition: getRstConditionByteDefinition(operand),
            instruction: `RST ${operand}`,
            byteLength: 1,
            cycleTime: 16,
            execute() {
                cpu.pushToStack(registers.programCounter.value);
                registers.programCounter.value = operandToAddress[operand];
            }
        });
    }
}
//# sourceMappingURL=create-call-and-return-operations.js.map